import { ReviewCard } from "@/containers/Parlor/ParlorDetailContainer/components/TabInfoSection/AmenityInfoTabPanel/ReviewCard";
import { Box, Button, Flex } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, HStack, Spacing, VStack } from "goi_common";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";

export const bestReviews = {
  "0": [
    {
      id: 121,
      headline:
        "예다함, 보람상조 같은 회사는 회사의 이익, 상주, 직원 순으로 중요시 여긴다고 하는데 고이상조의 경우에는..",
      good: "상주가 일번, 그리고 직원, 회사 순이라는 지도사님께서 주신 말씀이 무엇보다 기억에 남습니다. 또 뵐 일이 없어야 좋겠지만, 이런 일이 생기면 저는 장례지도사님과 고이상조를 선택하고 또 주변에 추천드릴 것 같습니다. 진심으로...",
      score: 5,
      created_at: "2023-07-27T23:50:15+09:00",
      user: {
        nickname: "김OO",
      },
    },
    {
      id: 111,
      headline:
        "예전 경험했던 다른 브랜드상조의 형식적인 꽃장식과는 비교불가일정도로 고인의 가시는길을 아름다운꽃으로 가득채워주셨습니다",
      good: "발인날 새벽부터 오셔서 발인제 준비와 유가족들 짐정리부터 해야할일들을 차근차근 알려주시고 엄숙한 발인제후 화장장으로 가서 예약해주신 시간표대로 기다림없이 화장후 장지인 추모공원에 수목장으로 고인을 모셨습니다. 모든 장례절차를 매끄럽게 마친후 다시 장례식장으로 돌아와 상복반납까지 체크해주신후에 팀장님과 인사를 나누고 떠나셨습니다",
      score: 5,
      created_at: "2023-07-03T21:17:15+09:00",
      user: {
        nickname: "강OO",
      },
    },
  ],

  "1": [
    {
      id: 67,
      headline:
        "음식 배분을 정말 잘해주셔서 음식값도 너무 나오지 않고 잘 아껴서 할 수 있었고 지도사님과 도우미분의 도움으로 상에 오신 분들이 정말 잘했다는 칭찬이 자자했습니다.",
      good: "입관식 과정에 많이 참여할 수 있게 해주셔서 저희도 너무 울지 않고 후회없이 할 말 다 하고 좋게 아버지 보내드릴 수 있었어요. 음식 배분을 정말 잘해주셔서 음식값도 너무 나오지 않고 잘 아껴서 할 수 있었고 지도사님과 도우미분의 도움으로 상에 오신 분들이 정말 잘했다는 칭찬이 자자했습니다.",
      score: 5,
      created_at: "2023-02-05T18:43:53.836562+09:00",
      user: {
        nickname: "전OO",
      },
    },
    {
      id: 62,
      headline:
        "장례식장도 갈팡질팡하던차예 장례식장 장단점을 차례대로 설명해주시고 해서 결정을 잘하게 되었습니다.",
      good: "갑자스러운 슬픔에 경황이없고 막막한 상황에 준비도 안된 상태에 전화로 알아보고 인터넷을 찾고  하는 찰라에 고이를 찾게 되었습니다. 좋은 평점에 의심은 했지만 댓글들을 읽고 합리적이고 전문적이라는 의견들이 많아 전화를 걸었습니다..",
      score: 5,
      created_at: "2023-02-26T12:35+09:00",
      user: {
        nickname: "이OO",
      },
    },
    {
      id: 111,
      headline:
        "밤 10시경 임종하셨기에 빈소를 바로 들어가지말고 안치후에 다음날 오전9시로 빈소예약을 잡아주셔서 빈소사용료도 2일치만 지출되게 도와주셨습니다",
      good: "빈소사용료도 2일치만 지출되게 도와주셨습니다. 모바일부고장과 영정사진도 즉시 만들어주셔서 너무 감사했습니다",
      score: 5,
      created_at: "2023-07-03T21:17:15+09:00",
      user: {
        nickname: "강OO",
      },
    },
    {
      id: 54,
      headline:
        "원하는 빈소가 만실이 되고 난감해하는 저희에게 빈소 정하는것부터 준비과정을 다 알아봐주셔서 어머님 보내드리는 일만 집중할수 있게 해주셨어요. ",
      good: "장례지내는동안 정말 세세한일까지 다 해결해주시고 궁금한점은 친절하게 이야기 해주셔 의지가 많이 됐습니다. 오신 친척분들도 어디서 저렇게 좋은분을 모셔왔냐면서 칭찬 많이 하셨어요. 명함도 받아가시구요.",
      score: 5,
      created_at: "2022-11-29T09:00:00+09:00",
      user: {
        nickname: "이OO",
      },
    },
  ],
  "2": [
    {
      id: 132,
      headline:
        "같이 노력해주신 임나라 장례지도사님, 제가 부족하여 감사함을 더 표하지 못해 죄송할 따름입니다. 거듭 감사드립니다. 상담해주시고 잘 챙겨주신 대표님, 내 살림하듯 아끼고 살뜰하게 음식과 손님 관리해주신 장례도우미님들.. 모두 감사합니다. ",
      good: "장례 기간 시기마다 필요한 것 챙겨주시고 알려주시고, 마음써주시고 같이 눈물 흘려주셔서 정말 큰 위로가 되었습니다. 아무리 일이라지만, 모든 일을 다 마음쓰며 하실 수 없으실텐데 같이 노력해주신 임나라 장례지도사님, 제가 부족하여 감사함을 더 표하지 못해 죄송할 따름입니다. 거듭 감사드립니다. 상담해주시고 잘 챙겨주신 대표님, 내 살림하듯 아끼고 살뜰하게 음식과 손님 관리해주신 장례도우미님들.. 모두 감사합니다. 생애 가장 힘들었던 시간을 지탱해주셨습니다.",
      score: 5,
      created_at: "2023-08-06T11:25:15+09:00",
      user: {
        nickname: "이OO",
      },
    },

    {
      id: 130,
      headline:
        "제사 지내는 방법, 이유 등등 을 알려주시는데 엄청 전문적이고 친절하게 알려주셨습니다 다시한번더 믿음이 가게되더라구요",
      good: "염 할때나 산소에 가서도 추가금이나 이런일들도 없고 모두 마무리 하고도 이것저것 알려주시고 또 궁금한건 아는 정도 에서는 다 알려준다고 해주셔서 정말 마음이 편안했습니다,",
      score: 5,
      created_at: "2023-08-01T16:31:15+09:00",
      user: {
        nickname: "송OO",
      },
    },
    {
      id: 106,
      headline:
        "장례지도사님이 입관 시간, 화장터 이용 시간 예약 잡아주셨는데 지나고 보니 세심하게 신경 써주신 거였어요.",
      good: "상조 서비스를 이용하기 전, '고이'에서 장례 관련 정보도 많이 얻고 해서 이곳을 이용해야겠다 생각하고 있었고,  믿고 맡길 수 있는 분이 필요했습니다. 선택할게 너무 많아서 혼란스러웠는데 잘 설명해주셨고, 불필요한 거 권하지 않으셔서 좋았습니다. 접객 도우미 여사님도 친절하셨어요. 입관 때 꽃을 많이 넣어주셔서 꽃밭에 누워 계신 아빠를 보니 마음이 너무 편안했습니다. 아버지 잘 보내드릴 수 있어 감사했습니다.",
      score: 5,
      created_at: "2023-06-12T22:48:15+09:00",
      user: {
        nickname: "이OO",
      },
    },
    {
      id: 93,
      headline:
        "추가금 없이 관 변경을 진행해주셨습니다. 가장 만족스러웠던 것은 입관이었습니다. 팀장님께선 실수로 꽃을 많이 사왔다고 하셨는데, 경력 상 그것은 거짓말이죠. 견적서 상 있는 금액으론 불가능한 정성이었어요",
      good: "추가금 없이 관 변경을 진행해주셨습니다. 가장 만족스러웠던 것은 입관이었습니다. 팀장님께선 실수로 꽃을 많이 사왔다고 하셨는데, 경력 상 그것은 거짓말이죠. 견적서 상 있는 금액으론 불가능한 정성이었어요.  혹시나 하는 마음에 미리 알아보길 잘 했던 것 같아요. 여러 상조의 견적을 받고, 너무 싸지만도 않고 적당히 저렴한 금액에 후기가 좋은 포에버라이프 상조를 선택하였습니다.",
      score: 5,
      created_at: "2023-04-25T20:59:00+09:00",
      user: {
        nickname: "윤OO",
      },
    },
    {
      id: 67,
      headline:
        "가장 중요하다고 생각했던 염습 및 사후목욕등 입관식도 너무 꼼꼼히 잘 해주시는게 특히나 너무 만족스러웠고 ",
      good: "입관식 과정에 많이 참여할 수 있게 해주셔서 저희도 너무 울지 않고 후회없이 할 말 다 하고 좋게 아버지 보내드릴 수 있었어요. 음식 배분을 정말 잘해주셔서 음식값도 너무 나오지 않고 잘 아껴서 할 수 있었고 지도사님과 도우미분의 도움으로 상에 오신 분들이 정말 잘했다는 칭찬이 자자했습니다.",
      score: 5,
      created_at: "2023-02-05T18:43:53.836562+09:00",
      user: {
        nickname: "전OO",
      },
    },
  ],
  "3": [
    {
      id: 132,
      headline:
        "사전에 부탁드렸던 대로 현장에서 안좋은 이야기 나오거나 실갱이 하는 부분 없이 해주셨어요.",
      good: "장례 자체도 경험해본 적이 없는데, 가까이 경험하는 첫 장례가 저희 아버지의 것일 거라는 상상도 해보지 못했습니다... 너무 황망하고 슬픈 와중에도 현실적으로 준비해야하는 장례식이라는 게 너무 어려웠는데 상조에서 챙겨주시고 마음써주셔서 잘 보내드렸습니다.",
      score: 5,
      created_at: "2023-08-06T11:25:00+09:00",
      user: {
        nickname: "이OO",
      },
    },
    {
      id: 134,
      headline:
        "기독교 장례와 비용 부분에서 고민이 많았던 저에게 처음 본사 상담부터 전문적임을 느끼게 해주셨습니다. ",
      good: " 처음 통화 부터 정성스러운 말투와 꼼꼼하게 시간대 별로 장례가 어떻게 진행 할지를 알려 주셨고, 입관 발인 화장 장지에서 모든 부분 꼼꼼히 챙겨 주셨습니다. ",
      score: 5,
      created_at: "2023-08-15T17:21:15+09:00",
      user: {
        nickname: "조OO",
      },
    },

    {
      id: 90,
      sangjo: {
        id: 10,
        name: "로이스의전",
        headColor: colors.gray400,
        color: "#FBE4D2",
        backgroundColor: "#190D05",
      },
      headline:
        "사용하지 않은 품목에 대해 정확이 짚어서 페이백 해주시는 모습에 경황이 없던 저희로서는 신뢰가 생겼습니다.",
      good: "2018년 같은 교회 언니 시어머님 상가에 조문 갔다 상조 진행으로 장례치르시는 것을 보게 되었습니다. 그때 언니뿐만 아니라 가족분들이 너무 만족하셔서 여쭤봤더니 후불제 상조라고 하시며 필요시 언제든지 전화하셔서 문의 하시면 된다고 하시더라구요. 저도 시어미님이 계신 상태라 상조 가입을 해야겠다고 생각하고 있던 중이라 간단한 상담만 받아보았습니다. 그리고 여러해가 지난후 병원에서 저희 시어머님 임종준비를 하시라고 하여 연락드렸더니 소천 하시게 되시면 요양병원으로 오셔서 모든 진행을 해 주신다고 하였습니다. 소천 하신 후 접수하니 정동수팀장님께서 직접 요양병원으로 오셔서 서류 확인과 함께 저희 어머님을 모셔서 장례식장까지 가신후 모든 장례 절차 상담과 함께 입관진행,발인,장지동행 마무리까지 해 주셨습니다. 정동수 팀장님꼐서 고인이 되신 어머님을 직접 오셔서 확인과 함께 장례진행을 다 해 주시니 더욱 믿음이 갔었고 입관 때 생화를 정성스럽게 관 장식해 주신 것과 저희들 종교가 기독교라고 본인이 십자가로 된 고깔을 제작 해 오셔서 올려 주셨는데 정말 많은 감동을 받았습니다. 교회에서 다른분들 입관예배 때 참석해서 보긴 하였지만 그렇게 이쁜 십자가 종이 고깔을 본 적이 없었습니다. 세상에서 하나밖에 없던거라 감명 깊었던 것 같습니다. 또한 사용하지 않은 품목에 대해 정확이 짚어서 페이백 해주시는 모습에 경황이 없던 저희로서는 신뢰가 생겼습니다. 다시 한번 정동수팀장님꼐 가족들을 대표하여 감사의 마음을 표하고 싶습니다. 정말 수고 많으셨습니다.",
      score: 5,
      created_at: "2022-11-29T09:00:00+09:00",
      user: {
        nickname: "김OO",
      },
    },
  ],

  "4": [
    {
      id: 129,
      headline: "합리적인 가격, 너무 좋은 장례지도사의 지원, 모든 것이 좋았습니다.",
      good: "합리적인 가격, 너무 좋은 장례지도사의 지원, 모든 것이 좋았습니다. 특별히 아쉬운 점이 없는게 ...",
      score: 5,
      created_at: "2023-07-28T16:23:00+09:00",
      user: {
        nickname: "독OO",
      },
    },

    {
      id: 107,
      sangjo: {
        id: 3,
        name: "친환경 장례서비스",
        headColor: colors.gray400,
        color: "#D4F34D",
        backgroundColor: "#1E4231",
      },

      headline: "견적 그대로 진행되었으며 추가사항에 대한 강요도 없었네요.",
      good: "갑작스러운 어머니의 임종이 다가오면서 급하게 인터넷 검색을 통해 고이장례연구소를 알게 되었고 두개의 업체에서 비슷한 내용의 장례 견적을 받았는데 친환경장례서비스의 강팀장님의 목소리가 다소 믿음이 전해졌고 역시나 장례진행에 있어서 아무것도 모르는저희를 장지까지 편안하게 잘 이끌어 주셨고 저희의 애로사항이나 어려운 부탁을 잘 이해해주시고 반영해 주셨네요. 견적 그대로 진행되었으며 추가사항에 대한 강요도 없었네요. 도우미 아주머니들도 무척 친절하시고 음식도 조문객 수에 맞추어 저희와 소통하면서 적절히 조절해 주셨고, 리무진과 버스 기사님도 관 운구시 도와주셔서 무척 감사했습니다. 강팀장님의 한발 빠른 대처와 진행으로 인하여 저로서는 어머니와의 마지막 시간을 좀더 집중하여 보낼 수 있었던것 같습니다. 강팀장님 다시 한번 깊은 감사드리고 이 분야에서 최선을 다하시는 당신을 응원하겠습니다.",
      score: 5,
      created_at: "2023-06-20T18:43:53.836562+09:00",
      user: {
        nickname: "손OO",
      },
    },

    {
      id: 119,
      headline:
        "말기암이던 동생이 호스피스 입원하고 있던 동안 상조회사를 검색했더니 여러 회사가 있었습니다. 그 중에 가장 믿을 만한 고이를 발견하게 되었도 대표님과 직접 통화를 통해 확정을 지었고 추가금 없이 무빈소로 진행하기로 했습니다. 장례 내내 김지훈 장례지도사님의 배려 덕분에 무탈없이 진행되었고 약속된 금액 이외에는 추가금도 없었습니다. 적극 추천합니다.",
      good: " 추가금 없이 무빈소로 진행하기로 했습니다. 장례 내내 김지훈 장례지도사님의 배려 덕분에 무탈없이 진행되었고 약속된 금액 이외에는 추가금도 없었습니다. 적극 추천합니다.",
      score: 5,
      created_at: "2023-07-26T23:44:00+09:00",
      user: {
        nickname: "김OO",
      },
    },
  ],
};

function SelectedReviews({
  path,
  title = "후기",
  to = 200,
}: {
  path?: any;
  title?: string;
  to?: number;
}) {
  const [tab, setTab] = useState("0");
  const router = useRouter();
  const currentReview = useMemo(() => {
    return bestReviews[tab as keyof typeof bestReviews];
  }, [tab, bestReviews]);
  return (
    <VStack gap="6px" width="100%" padding="0 0 24px">
      <HStack
        width="100%"
        className="subtitle_16_b gray900"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box as="h3" whiteSpace="pre-line">
          {title}
        </Box>
        <HStack
          alignItems="center"
          gap={2}
          onClick={() => {
            router.push("/review");
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "selected_review-uv_review",
              },
            });
          }}
        >
          <Box className="caption_12_b gray500">후기 더보기</Box>
          <Box>
            <ColorIcon name="arrow_right_small" color={colors.gray600} size={12} />
          </Box>
        </HStack>
      </HStack>
      <Spacing gap={6} />
      <Flex width="100%" flexWrap="wrap">
        <Button
          border="none"
          onClick={() => {
            setTab("1");
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "review-button_category",
                text: "장례식장 고민, 빈소 할인",
              },
            });
          }}
          variant={tab === "1" ? "solid" : "outline"}
          width="50%"
          fontSize={12}
          colorScheme="blackAlpha"
        >
          # 장례식장 비교, 빈소 할인
        </Button>
        <Button
          border="none"
          onClick={() => {
            setTab("2");
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "review-button_category",
                text: "장례식장 고민, 빈소 할인",
              },
            });
          }}
          variant={tab === "2" ? "solid" : "outline"}
          width="50%"
          fontSize={12}
          colorScheme="blackAlpha"
        >
          # 세심하게 챙기는 장례지도사
        </Button>
        <Button
          border="none"
          onClick={() => {
            setTab("3");
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "review-button_category",
                text: "장례식장 고민, 빈소 할인",
              },
            });
          }}
          variant={tab === "3" ? "solid" : "outline"}
          width="50%"
          fontSize={12}
          colorScheme="blackAlpha"
        >
          # 친절하고 전문적인 상담
        </Button>
        <Button
          border="none"
          onClick={() => {
            setTab("4");
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "review-button_category",
                text: "장례식장 고민, 빈소 할인",
              },
            });
          }}
          variant={tab === "4" ? "solid" : "outline"}
          width="50%"
          fontSize={12}
          colorScheme="blackAlpha"
        >
          # 바가지 없는 장례 용품
        </Button>
      </Flex>
      <VStack width="100%">
        {currentReview.map((r) => (
          <ReviewCard
            key={r.id + "reviewslick"}
            {...r}
            event={{
              path,
              trigger_and_target: "review_detail",
            }}
          />
        ))}
      </VStack>
    </VStack>
  );
}

export default SelectedReviews;
